
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

export type ButtonType = {
  name: string;
  class?: string[];
  callback: () => void;
};

@Component
export default class Dialog extends Vue {
  @Prop({ default: '' }) readonly text!: string
  @Prop({ default: '' }) readonly title!: string
  @Prop(String) readonly wrapperClassName!: string
  @Prop({ default: () => ([]) }) readonly buttons!: ButtonType[]
}
